import { ReactNode } from "react";
import { Whisper, Tooltip } from "rsuite";
import { TypeAttributes } from "rsuite/esm/internals/types";

interface InfoToolipProps {
  text: ReactNode;
  size?: number;
  iconCSS?: string;
  placement?: TypeAttributes.Placement;
  styles?: object;
}

const InfoToolip = ({
  text,
  size = 16,
  iconCSS = "",
  placement = "auto",
  styles = {},
}: InfoToolipProps) => {
  return (
    <Whisper
      preventOverflow
      placement={placement}
      trigger="hover"
      delayOpen={300}
      speaker={<Tooltip>{text}</Tooltip>}
    >
      <i
        className={`mdi mdi-information-outline cursor-pointer ${iconCSS}`}
        style={{ fontSize: size, ...styles }}
        tabIndex={-1}
      />
    </Whisper>
  );
};

export default InfoToolip;
